import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  apiUrl: '/api/',
  envLabel: 'TST',
  googleAuthEnabled: true,
  subscriptionCheckoutUrl:
    'https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=2962ab681d9c4a668e77e24765fcd611',
  supportWhatsappUrl: 'https://wa.me/5493571326047',
  clarityProjectId: 'z29pnlllfg',
  firebase: {
    apiKey: 'AIzaSyDGlsfbQv9PiogoGwXFOkkmvJH72bhSVzc',
    authDomain: 'garage-digital-tst.firebaseapp.com',
    projectId: 'garage-digital-tst',
    storageBucket: 'garage-digital-tst.firebasestorage.app',
    messagingSenderId: '708362952604',
    appId: '1:708362952604:web:c9ba61c541d9c78e91b259',
    measurementId: 'G-FPRX2S6WW0',
  },
};
